import { array, option } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { UseQueryResult } from '@tanstack/react-query';
import { BookablePeriod, useRepositoryQuery } from '@mews-commander/data-access';
import { createOption } from '@mews-commander/ui';
import { Option, WithEnterpriseId } from '@mews-commander/types';
import { useCancellationPolicyNameGetter } from '../../../../../components';

interface Params extends WithEnterpriseId {
    bookablePeriod?: 'Month' | 'Night' | 'Day' | 'Hour';
}

export const useLocalCancellationPolicyOptions = ({
    enterpriseId,
    bookablePeriod,
}: Params): UseQueryResult<Option[]> => {
    const getCancellationPolicyName = useCancellationPolicyNameGetter();

    return useRepositoryQuery(
        'cancellationPolicies',
        'getAll',
        {
            // @ts-expect-error, incorrect OpenAPI schema definition
            ids: null,
            enterpriseId,
            bookablePeriod: bookablePeriod as BookablePeriod,
        },
        {
            select: flow(
                (result) => option.fromNullable(result),
                option.map(
                    array.map((cancellationPolicy) => {
                        const constructedName = getCancellationPolicyName(cancellationPolicy, { format: 'parameters' });
                        return createOption({
                            label: cancellationPolicy.name || constructedName,
                            secondaryText: cancellationPolicy.name ? constructedName : null,
                            value: cancellationPolicy.id,
                        });
                    })
                ),
                option.getOrElse(() => [] as Option[])
            ),
        }
    );
};
